'use client';

import React from 'react';

import { Media } from '@/components/Media';
import { ModalForm } from '@/components/ModalForm';
import { Button } from '@ui/button';
import { Svg } from '@ui/svg';
import type { Service, Misc } from '@/payload-types';

import spy from './assets/spy.svg';
import heart from './assets/heart.svg';
import medicalKit from './assets/medical-kit.svg';
import hours from './assets/24hours.svg';

const features = [
  { title: 'Анонимно', icon: spy },
  { title: 'Поможем', icon: heart },
  { title: 'Эффективно', icon: medicalKit },
  { title: 'Без выходных', icon: hours },
];

export const Hero: React.FC<
  Service & {
    misc: Misc;
  }
> = ({ title, image, misc }) => {
  const { phones } = misc.refs;

  const isLongFirstWord = title.split(' ')[0].length > 13;

  return (
    <section
      className="border-blue corners relative flex items-start gap-6 overflow-hidden border p-[15px] lg:flex-col"
      data-name="Hero"
    >
      <div className="w-full max-w-[586px] pt-[45px] pb-14 lg:max-w-none lg:pt-0 lg:pb-0">
        <h1 className="h1 text-blue relative mb-[27px] md:mb-5">
          <div className="relative z-10 w-fit rounded-[24px] bg-[#FAFAFA] py-2 pr-5 sm:text-[26px] md:p-0">
            {title}
          </div>
          {isLongFirstWord && (
            <>
              <Svg
                className="absolute bottom-full left-[calc(100%+24px)] z-10 md:hidden"
                id="corner"
              />
              <Svg
                className="absolute top-full left-[calc(100%+24px)] z-10 rotate-90 md:hidden"
                id="corner"
              />
            </>
          )}
        </h1>

        <div className="h7 mb-16 grid max-w-[360px] grid-cols-2 gap-2 lg:mb-8">
          {features.map((i) => (
            <div className="flex items-center gap-2" key={i.title}>
              <Media
                className="flex-center jus aspect-square w-8 rounded-full bg-gray-700"
                src={i.icon}
                priority
              />
              <div>{i.title}</div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <ModalForm toggle={<Button>Заказать звонок</Button>} />
          {phones?.[0] && (
            <a
              className="h6 link-secondary text-blue"
              href={`tel:${phones[0].phone}`}
            >
              {phones[0].phone}
            </a>
          )}
        </div>
      </div>

      <Media
        className="corners relative aspect-[726/472] w-full max-w-[726px] overflow-hidden"
        resource={image}
        fill
        priority
      />
    </section>
  );
};
